"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertDocumentsToCompletedProjectsDictionary = exports.skipDueToSize = exports.sortProductsByDimensions = exports.isValidProduct = exports.findPossiblePoints = exports.getAduPolygon = void 0;
const core_1 = require("@natomas-org/core");
const turf = __importStar(require("@turf/turf"));
const turf_1 = require("@turf/turf");
const general_1 = require("./general");
const ArcGIS_1 = require("../ArcGIS");
const accessors_1 = require("../accessors");
const FirebaseNatService_1 = require("../Firebase/FirebaseNatService");
const getAduPolygon = (feasibleArea, unitPlacement, propertyGeometry, currentUnit, addressDetails, lookUpCoordinates) => {
    // We place the ADU at the center of the feasible area
    /**
     * TODO - if we have multiple feasible areas, (like front yard vs back yard)
     * we should find the largest one and place it there
     *  */
    const dimensionsInInches = core_1.Product.getLengthAndDepthInInches(currentUnit);
    const aduSides = [
        dimensionsInInches[0],
        dimensionsInInches[1],
        dimensionsInInches[0],
        dimensionsInInches[1],
    ];
    // @ts-ignore
    let feasibleAreaCenterPoint = turf.center(feasibleArea);
    let bearing = 90;
    let result = [];
    if (propertyGeometry &&
        (0, general_1.hasSavedPlacement)(unitPlacement) &&
        ((unitPlacement === null || unitPlacement === void 0 ? void 0 : unitPlacement.addressId) === core_1.Address.getId(addressDetails) ||
            (unitPlacement === null || unitPlacement === void 0 ? void 0 : unitPlacement.addressId) ===
                core_1.Address.getDeprecatedId_before_03_23(addressDetails))) {
        const coords = unitPlacement.coordinates.map((coord) => {
            return [coord.lng, coord.lat];
        });
        feasibleAreaCenterPoint = (0, turf_1.point)(coords[0]);
        if (!!(unitPlacement === null || unitPlacement === void 0 ? void 0 : unitPlacement.productId) &&
            currentUnit.id === (unitPlacement === null || unitPlacement === void 0 ? void 0 : unitPlacement.productId)) {
            coords.forEach((coord) => {
                result.push((0, turf_1.point)(coord));
            });
            result.push(feasibleAreaCenterPoint);
            // @ts-ignore
            const finalShape = [result.map((point) => turf.coordAll(point)[0])];
            return { polygon: turf.polygon(finalShape) };
        }
        bearing = getBearings(coords);
    }
    result = [feasibleAreaCenterPoint];
    let counter = 0;
    for (const side of aduSides) {
        if (counter >= 3) {
            continue;
        }
        result.push(
        // @ts-ignore
        turf.rhumbDestination(result[result.length - 1], side, bearing, {
            units: "inches",
        }));
        bearing += 90;
        counter += 1;
    }
    result.push(feasibleAreaCenterPoint);
    // @ts-ignore
    const finalShape = [result.map((point) => turf.coordAll(point)[0])];
    const aduPolygon = turf.polygon(finalShape);
    /*
    Look up coordinates are used to help the performance of the auto-placement algorithm
    It looks at the last coordinates that fit a unit and iterates through them first.
    The idea is that hopefully this find a fit and not need to compute the other coordinates
     */
    if (lookUpCoordinates) {
        const sortedCoordinates = lookUpCoordinates.sort((a, b) => {
            return a.foundFit === b.foundFit ? 0 : a.foundFit ? -1 : 1;
        });
        for (let i = 0; i < sortedCoordinates.length; i++) {
            const coordinate = sortedCoordinates[i];
            const fitPolygon = determineIfPositionFits(aduPolygon, feasibleArea, coordinate.coordinate);
            if (fitPolygon) {
                coordinate.foundFit = true;
                return {
                    polygon: fitPolygon,
                    foundCoordinate: {
                        foundFit: true,
                        coordinate: coordinate.coordinate,
                    },
                };
            }
        }
    }
    return {
        polygon: aduPolygon,
    };
};
exports.getAduPolygon = getAduPolygon;
const determineIfPositionFits = (aduPolygon, feasibleArea, center) => {
    const basePolygon = setCenter(aduPolygon, center);
    const withinPolygons = [];
    for (let i = 0; i < 240; i++) {
        const newPolygon = (0, turf_1.transformRotate)(basePolygon, 1.5 * i, {
            pivot: center,
        });
        if (feasibleArea && (0, turf_1.booleanWithin)(newPolygon, feasibleArea)) {
            const line = (0, turf_1.polygonToLine)(newPolygon);
            const intersect = (0, turf_1.lineIntersect)(line, feasibleArea);
            if (intersect.features.length < 1) {
                withinPolygons.push(newPolygon);
            }
        }
        else if (withinPolygons.length > 0) {
            break;
        }
    }
    if (withinPolygons.length > 0) {
        return withinPolygons[Math.floor(withinPolygons.length / 2)];
    }
    return null;
};
const findPossiblePoints = (feasibleArea) => {
    // diagonal length of ADU
    const minDistance = 10;
    const possiblePoints = [];
    function findLongestDiagonal(_coordinates) {
        const coordinates = [];
        if (_coordinates.length > 0) {
            let lastCoordinateUsed = (0, turf_1.point)(_coordinates[0]);
            for (let i = 0; i < _coordinates.length; i++) {
                const currentCoordinate = _coordinates[i];
                const nextCoordinate = _coordinates[(i + 1) % _coordinates.length];
                const pointA = (0, turf_1.point)(currentCoordinate);
                const pointB = (0, turf_1.point)(nextCoordinate);
                const distanceInFeet = (0, turf_1.distance)(pointA, pointB, {
                    units: "feet",
                });
                if (distanceInFeet > 5) {
                    coordinates.push(currentCoordinate);
                    lastCoordinateUsed = pointA;
                }
                else {
                    const distanceInFeetSinceLastUsedPoint = (0, turf_1.distance)(pointA, lastCoordinateUsed, {
                        units: "feet",
                    });
                    if (distanceInFeetSinceLastUsedPoint > 5) {
                        coordinates.push(currentCoordinate);
                        lastCoordinateUsed = pointA;
                    }
                }
                if (distanceInFeet > 10) {
                    const midpoint = turf.midpoint(currentCoordinate, nextCoordinate);
                    if (midpoint.geometry.coordinates) {
                        coordinates.push(midpoint.geometry.coordinates);
                        lastCoordinateUsed = midpoint;
                    }
                }
            }
        }
        coordinates.forEach((point1) => {
            const pointA = (0, turf_1.point)(point1);
            coordinates.forEach((point2) => {
                const pointB = (0, turf_1.point)(point2);
                const distanceInFeet = (0, turf_1.distance)(pointA, pointB, { units: "inches" });
                if (distanceInFeet > minDistance) {
                    const positionA = point1;
                    const positionB = point2;
                    const intersect = (0, turf_1.lineIntersect)({ coordinates: [positionA, positionB], type: "LineString" }, feasibleArea);
                    // It will always intersect with the initial points, so 3 or more means that there is another intersection
                    if (intersect.features.length <= 2) {
                        const point = turf.midpoint(point1, point2);
                        possiblePoints.push({ coordinate: point, foundFit: false });
                    }
                }
            });
        });
    }
    // @ts-ignore
    if (feasibleArea.geometry.coordinates) {
        // @ts-ignore
        feasibleArea.geometry.coordinates.forEach((coordinateRoot) => {
            // @ts-ignore
            if (feasibleArea.geometry.type === "MultiPolygon") {
                findLongestDiagonal(coordinateRoot[0]);
            }
            else {
                findLongestDiagonal(coordinateRoot);
            }
        });
    }
    return possiblePoints;
};
exports.findPossiblePoints = findPossiblePoints;
const isValidProduct = (product) => {
    var _a, _b;
    if (!product ||
        !(product === null || product === void 0 ? void 0 : product.productDetails) ||
        !((_a = product === null || product === void 0 ? void 0 : product.productDetails) === null || _a === void 0 ? void 0 : _a.dimensions)) {
        return false;
    }
    const [length, depth] = core_1.Product.getLengthAndDepthInInches(product);
    return (length > 0 &&
        depth > 0 &&
        ((_b = product === null || product === void 0 ? void 0 : product.productDetails) === null || _b === void 0 ? void 0 : _b.squareFeet) > 0 &&
        (product === null || product === void 0 ? void 0 : product.id));
};
exports.isValidProduct = isValidProduct;
const sortProductsByDimensions = (products) => {
    return products.sort((product1, product2) => {
        const [length1, depth1] = core_1.Product.getLengthAndDepthInInches(product1);
        const [length2, depth2] = core_1.Product.getLengthAndDepthInInches(product2);
        // Prioritize units that have shorter lengths and depths
        if (length1 <= length2 && depth1 <= depth2) {
            return -1;
        }
        if (length2 <= length1 && depth2 <= depth1) {
            return 1;
        }
        // Prioritize units that have smaller perimeters
        if (length1 + depth1 <= length2 + depth2) {
            return -1;
        }
        return 1;
    });
};
exports.sortProductsByDimensions = sortProductsByDimensions;
const skipDueToSize = (product, productPlacementMap) => {
    const productsWithoutFit = Object.values(productPlacementMap).filter((productItem) => { var _a; return !((_a = productItem === null || productItem === void 0 ? void 0 : productItem.productInfoAndPlacement) === null || _a === void 0 ? void 0 : _a.productFits); });
    return productsWithoutFit.some((productWithoutFit) => {
        var _a, _b;
        if (!((_a = productWithoutFit === null || productWithoutFit === void 0 ? void 0 : productWithoutFit.productInfoAndPlacement) === null || _a === void 0 ? void 0 : _a.dimensions)) {
            return false;
        }
        const [length1, depth1] = core_1.Product.getLengthAndDepthInInches(product);
        const [length2, depth2] = (_b = productWithoutFit === null || productWithoutFit === void 0 ? void 0 : productWithoutFit.productInfoAndPlacement) === null || _b === void 0 ? void 0 : _b.dimensions;
        return length1 >= length2 && depth1 >= depth2;
    });
};
exports.skipDueToSize = skipDueToSize;
const getBearings = (coords) => {
    return ((Math.atan2(coords[1][0] - coords[0][0], coords[1][1] - coords[0][1]) *
        180) /
        Math.PI);
};
const setCenter = (aduPolygon, newCenter) => {
    const polyCentroid = (0, turf_1.center)(aduPolygon);
    const bearingBetween = (0, turf_1.bearing)(polyCentroid.geometry.coordinates, newCenter.geometry.coordinates);
    const distanceCentroids = (0, turf_1.distance)(newCenter, polyCentroid, {
        units: "meters",
    });
    return (0, turf_1.transformTranslate)(aduPolygon, distanceCentroids, bearingBetween, {
        units: "meters",
    });
};
function convertDocumentsToCompletedProjectsDictionary(documentDataArray) {
    const projectDictionary = {};
    documentDataArray.forEach((doc) => {
        var _a;
        const data = (0, FirebaseNatService_1.getDocInfo)(doc);
        if (!data || !(data === null || data === void 0 ? void 0 : data.code)) {
            return;
        }
        const dataAddress = data === null || data === void 0 ? void 0 : data.project_address;
        const address = (0, core_1.addressFSToNatomas)(dataAddress);
        const addressCoordinates = core_1.Address.getCoordinates(address !== null && address !== void 0 ? address : undefined);
        let randomizedCoordinates = undefined;
        if (!!addressCoordinates && (addressCoordinates === null || addressCoordinates === void 0 ? void 0 : addressCoordinates.length) > 1) {
            const randomizedCoordinatesPoint = (0, ArcGIS_1.randomizeCoordinatesWithinGivenRadius)(addressCoordinates[0], addressCoordinates[1], core_1.LOCATION_RANDOMIZATION_RADIUS_METERS);
            if (!!(randomizedCoordinatesPoint === null || randomizedCoordinatesPoint === void 0 ? void 0 : randomizedCoordinatesPoint.coordinates) &&
                ((_a = randomizedCoordinatesPoint === null || randomizedCoordinatesPoint === void 0 ? void 0 : randomizedCoordinatesPoint.coordinates) === null || _a === void 0 ? void 0 : _a.length) > 1) {
                randomizedCoordinates = {
                    lat: randomizedCoordinatesPoint === null || randomizedCoordinatesPoint === void 0 ? void 0 : randomizedCoordinatesPoint.coordinates[1],
                    lng: randomizedCoordinatesPoint === null || randomizedCoordinatesPoint === void 0 ? void 0 : randomizedCoordinatesPoint.coordinates[0],
                };
            }
        }
        projectDictionary[data === null || data === void 0 ? void 0 : data.code] = Object.assign({
            randomizedCoordinates: randomizedCoordinates,
        }, data, {});
        projectDictionary[data === null || data === void 0 ? void 0 : data.code].displayType =
            accessors_1.PublicProjectInfo.hasEnrichedData(projectDictionary[data === null || data === void 0 ? void 0 : data.code])
                ? core_1.PublicProjectDisplayType.COMPLETED_ENRICHED
                : core_1.PublicProjectDisplayType.COMPLETED;
    });
    return projectDictionary;
}
exports.convertDocumentsToCompletedProjectsDictionary = convertDocumentsToCompletedProjectsDictionary;
//# sourceMappingURL=structures.js.map